import SideBarTool from '@/commons/components/side-bar-tool';
import './index.less';
import { useContext, useEffect, useState } from 'react';
import classNames from 'classnames';
import { useParams } from 'react-router-dom';
import { Skeleton, message } from 'antd';
import { SideBarBtnType } from '@/commons/enums/side-bar-btn-type';
import genUUID from '@/commons/utils/gen-uuid';
import { SystemContext } from '@/App';
import { SystemStatus } from '@/commons/context/system-store';
import { Model } from '@/commons/interface/project/model';
import { findSiteModel } from '@/api/project/model';
import { Building } from '@/commons/interface/project/building';
import { createBuilding, findBuildingsWithModelsByProjectUuid } from '@/api/project/building';
import TnMessage from '@/commons/widget/message';
import BuildingItem from './building-item';
import TnInput from '@/commons/widget/input/tn-input';
import ModelItem from './model-item';

interface IProps {

}

export default function ModelFilePanel(props: IProps) {

    const { projectUuid, modelUuid, branchUuid } = useParams();

    const systemContext = useContext<SystemStatus>(SystemContext);

    const [previewModelUuids, setPreviewModelUuids] = useState<string[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [adding, setAdding] = useState<boolean>(false); // 正在添加楼栋
    const [addName, setAddName] = useState<string>(''); // 正在添加的楼栋的名称


    const [buildingList, setBuildingList] = useState<Building[]>([]); // 楼栋列表
    const [siteModel, setSiteModel] = useState<Model>(); // 场地模型

    useEffect(() => {
        if (!projectUuid) return;
        generateData();
    }, [projectUuid])

    useEffect(() => {
        setPreviewModelUuids(systemContext?.showModelUuidList || []);
    }, [systemContext.showModelUuidList])

    // 获得模型列表
    const generateData = () => {
        setLoading(true);
        // 获得场地模型
        findSiteModel(projectUuid).then(res => {
            let siteModel: Model = res.data
            if (modelUuid == siteModel.uuid && !!branchUuid) {
                siteModel.expanded = true;
            }
            setSiteModel(siteModel);
        })
        // 获得携带模型的楼栋
        findBuildingsWithModelsByProjectUuid(projectUuid).then(res => {
            let data: Building[] = res.data || [];
            let currentBuilding = data.find(item => item.uuid == systemContext.currentBuildingUuid);
            if (currentBuilding) {
                currentBuilding.expanded = true;
                let currentModel = currentBuilding.modelList.find(item => item.uuid == modelUuid);
                if (currentModel && !!branchUuid) {
                    currentModel.expanded = true;
                }
            }
            setBuildingList(data);
        }).catch(err => {
            TnMessage.error("获得数据失败")
        }).finally(() => {
            setLoading(false);
        })
    }

    useEffect(() => {
        if (adding) {
            // 滚动到添加的输入框
            let ele = document.getElementById('add-input');
            if (ele) {
                ele.scrollIntoView(true);
            }
        }
    }, [adding])

    // 点击了添加楼栋的按钮
    const onAddBtnClick = () => {
        setAdding(true);
        setAddName("");
    }

    // 添加楼栋
    const onAddSave = () => {
        if (!addName || addName?.trim()?.length === 0) {
            setAdding(false);
            setAddName("");
            return;
        }
        let uuid = genUUID();
        let building: Building = {
            uuid: uuid,
            projectUuid: projectUuid,
            name: addName,
        }
        createBuilding(building).then(res => {
            if (res.status === 200) {
                building.id = res.data;
                buildingList.push(building);
                setBuildingList([...buildingList]);
                message.success("添加成功");
                setAdding(false);
                setAddName("");
            }
        }).catch(err => {
            message.error("添加失败");
        })
    }

    // const togglePreview = (uuid: string) => {
    //     if (uuid === modelUuid && !branchUuid) return;
    //     let newPreviewModelUuids = [...previewModelUuids];
    //     let idx = newPreviewModelUuids?.findIndex(item => item === uuid);
    //     if (idx === -1) {
    //         newPreviewModelUuids.push(uuid);
    //     } else {
    //         newPreviewModelUuids.splice(idx, 1);
    //     }
    //     systemContext.setShowModelUuidListValue(newPreviewModelUuids);
    // }

    return (
        <div className='side-bar-main'>
            <SideBarTool
                activeBtnList={[SideBarBtnType.ADD]}
                onAddBtnClick={onAddBtnClick}
            />
            <div className="body">
                <div className="title">
                    模型
                </div>
                <Skeleton loading={loading} active>
                    <div className='detail model-panel'>
                        <ModelItem
                            className="building-style-model"  // 使用一个特殊的类名来控制样式
                            model={siteModel}
                            onUpdateModel={data => {
                                let newModel = { ...siteModel, ...data };
                                setSiteModel(newModel);
                            }}
                            onDeleteModel={() => {
                                setSiteModel(null)
                            }}
                            // togglePreview={modelUuid => {
                            //     togglePreview(modelUuid);
                            // }}
                            // isShow={previewModelUuids.includes(siteModel?.uuid)}
                        />
                        {buildingList.map((building, index) => (
                            <BuildingItem
                                key={index}
                                building={building}
                                onDeleteBuilding={() => {
                                    let newList = [...buildingList];
                                    newList.splice(index, 1);
                                    setBuildingList([...newList]);
                                }}
                                onUpdateBuilding={(data) => {
                                    let newBuilding = { ...building, ...data };
                                    buildingList.splice(index, 1, newBuilding);
                                    setBuildingList([...buildingList]);
                                }}
                                // togglePreview={modelUuid => {
                                //     togglePreview(modelUuid);
                                // }}
                                previewModelUuids={previewModelUuids}
                            />
                        ))}
                        {adding && <div className={classNames({
                            'building-title': true,
                        })} id="add-input">
                            <TnInput
                                value={addName}
                                onTextChange={(value) => setAddName(value)}
                                onPressEnter={onAddSave}
                                onEscapeKeyDown={() => {
                                    setAdding(false);
                                    setAddName("");
                                }}
                                onBlur={onAddSave}
                                placeholder='输入楼栋名称'
                                autoFocus
                            />
                        </div>}
                    </div>
                </Skeleton>
            </div>
        </div>
    )
}